module.exports = __webpack_public_path__ + "img/logo.70d3cca7.png";